import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import styles from './styles.module.scss'

import { API, API_ROUTER } from '../../../../api'
import NoImage from '../../../../assets/no-image.png'

export default function CupParticipants() {
  const [participants, setParticipants] = useState()
  let { id } = useParams()

  useEffect(() => {
    API.request({
      ...API_ROUTER.tournaments.getTournamentMembers,
      pathKeys: {
        tournamentId: id,
      },
    })
      .then(res => {
        setParticipants(res)
      })
      .catch(err => console.log(err))
  }, [])

  const getParticipantCards = () => {
    return participants.members.map((participant, i) => {
      const { user, team } = participant
      const isTeam = !!team?.id
      const displayName = team?.name || user?.nickname
      const displayImage = team?.logo || user?.avatar || NoImage
      const profileLink = isTeam
        ? `/teams/team/${team?.id}`
        : `/id/${user?.url}`

      return (
        <Link
          key={participant.id || i}
          to={profileLink}
          className={styles.participantCard}
        >
          <div className={styles.cardHeader}>
            <div className={styles.rankBadge}>
              <span className={styles.rankNumber}>#{i + 1}</span>
            </div>
            <div className={styles.participantInfo}>
              <div className={styles.imageContainer}>
                <img
                  className={styles.participantImage}
                  src={displayImage}
                  alt={displayName}
                />
                {isTeam && <div className={styles.teamIndicator}>TEAM</div>}
              </div>
              <div className={styles.participantDetails}>
                <h3 className={styles.participantName}>{displayName}</h3>
                {isTeam && user?.nickname && (
                  <p className={styles.captainName}>Captain: {user.nickname}</p>
                )}
              </div>
            </div>
          </div>
          <div className={styles.cardFooter}>
            <div className={styles.clickIndicator}>
              <span className={styles.clickText}>View Details</span>
              <div className={styles.arrowIcon}>→</div>
            </div>
          </div>
        </Link>
      )
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <FormattedMessage id='battlecup.participants.team' />
        </h2>
        <div className={styles.participantCount}>
          {participants?.members.length || 0} participants
        </div>
      </div>

      <div className={styles.participantsGrid}>
        {participants?.members.length ? (
          getParticipantCards()
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>👥</div>
            <p className={styles.emptyText}>
              <FormattedMessage id='battlecup.participants.noParticipants' />
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
